import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustIndicators from './components/TrustIndicators';
import ClientLogos from './components/ClientLogos';
import WieZijnWij from './components/WieZijnWij';
import WatDoenWij from './components/WatDoenWij';
import HowItWorks from './components/HowItWorks';
import VoorWie from './components/VoorWie';
import USPSection from './components/USPSection';
import Testimonials from './components/Testimonials';
import InstagramSection from './components/InstagramSection';
import FAQ from './components/FAQ';
import GeenBedrijf from './components/GeenBedrijf';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Popups from './components/Popups';
import { useSEO } from '../../hooks/useSEO';
import { SITE_URL } from '../../utils/siteConfig';

export default function Home() {
  useSEO({
    title: 'Direct uit China Inkopen | Goedkoop Inkopen uit China | DUC Sourcing Agent',
    description: 'Direct uit China inkopen en goedkoop producten importeren? DUC is uw sourcing agent voor product sourcing, private label & import uit China. Bespaar 30–80%. Gratis offerte binnen 24 uur.',
    keywords: 'direct uit china, inkopen uit china, goedkoop inkopen, goedkoop inkopen uit China, sourcing China, product sourcing, import China, leverancier China vinden, private label China, DDP levering',
    canonical: `${SITE_URL}/`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Direct uit China Inkopen — DUC Sourcing Agent',
      description: 'Direct uit China inkopen en goedkoop producten importeren via sourcing agent DUC. Product sourcing, private label, DDP levering en importbemiddeling voor Nederlandse ondernemers.',
      url: SITE_URL,
      breadcrumb: { '@type': 'BreadcrumbList', itemListElement: [{ '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL }] },
    },
  });

  return (
    <div className="relative overflow-x-hidden font-sans bg-white">
      <Navbar />
      <HeroSection />
      <TrustIndicators />
      <ClientLogos />
      <WieZijnWij />
      <WatDoenWij />
      <HowItWorks />
      <VoorWie />
      <USPSection />
      <Testimonials />
      <InstagramSection />
      <FAQ />
      <GeenBedrijf />
      <CTASection />
      <Footer />
      <Popups />
    </div>
  );
}
